export const TOGGLE_STICKY_FILTERS = 'TOGGLE_STICKY_FILTERS';

export function toggleStickyFilters(bool) {
    return {
        type: TOGGLE_STICKY_FILTERS,
        bool
    };
}
